import _regeneratorRuntime from "D:\\workFile\\qingbeiCode\\qingbei-pc\\node_modules\\@babel\\runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Question from "@/components/ques/Question";
export default {
  name: "ExamAnalysis",
  components: {
    Question: Question
  },
  props: {
    reportType: {
      type: String,
      default: ""
    }
  },
  data: function data() {
    return {
      list: [],
      visible: false,
      questionType: "",
      answer: {},
      fixed: false,
      fixedRight: 0,
      scantron: {
        list: []
      },
      section: {},
      showQuestion: {},
      ids: [],
      scrollbarWrap: null
    };
  },
  computed: {
    hasSection: function hasSection() {
      if (this.scantron.data.length == 0) {
        return false;
      }

      return !!this.scantron.data[0].child;
    }
  },
  created: function () {
    var _created = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2() {
      var _this = this;

      var data, parent_id;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.$http.post("/api/app/practice/scantron", {
                report_id: this.$route.query.id,
                type: 1,
                status: this.$route.query.type
              });

            case 2:
              this.scantron = _context2.sent;
              this.scantron.data.forEach(function (t) {
                if (!t.child) {
                  return;
                }

                t.child.forEach(function (ques, index) {
                  if (index == 0) {
                    _this.$set(_this.section, ques.sort, {
                      name: t.name,
                      introduce: t.introduce
                    });
                  }
                });
              });
              _context2.next = 6;
              return this.$http.post("/api/app/practice/analysis", {
                report_id: this.$route.query.id,
                type: this.$route.query.type
              });

            case 6:
              data = _context2.sent;
              parent_id = "";
              console.log(data);
              data.forEach(function (ques, index) {
                if (ques.parent_id != parent_id) {
                  parent_id = ques.parent_id;
                  ques.is_sub_first = true;

                  if (index > 0) {
                    data[index - 1].is_sub_last = true;
                  }
                }

                ques.index = index + 1;

                if (ques.ques_type != 5 && ques.ques_option && typeof ques.ques_option === "string") {
                  ques.ques_option = JSON.parse(ques.ques_option);
                }

                if (ques.ques_type == 1 || ques.ques_type == 2) {
                  var id = ques.ques_option.filter(function (o) {
                    return o.is_right == 1;
                  })[0].id;

                  _this.$set(_this.answer, ques.question_id, id);
                } else if (ques.ques_type == 3 || ques.ques_type == 4) {
                  var ids = [];
                  ques.ques_option.filter(function (o) {
                    return o.is_right == 1;
                  }).forEach(function (o) {
                    ids.push(o.id);
                  });

                  _this.$set(_this.answer, ques.question_id, ids);
                } else if (ques.ques_type == 7) {
                  _this.$set(_this.answer, ques.question_id, ques.right_answer.map(function (item) {
                    return Array.isArray(item) ? item.join("、") : item;
                  }));
                }

                _this.$set(_this.showQuestion, ques.index, true);

                _this.ids.push(ques.index);
              });
              this.list = data;
              this.$nextTick(
              /*#__PURE__*/
              _asyncToGenerator(
              /*#__PURE__*/
              _regeneratorRuntime.mark(function _callee() {
                var size, count, _loop, i;

                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _this.showContent();

                        size = 20;
                        count = parseInt(_this.ids.length / size);

                        if (_this.ids.length % size > 0) {
                          count++;
                        }

                        _loop = function _loop(i) {
                          var showIds = _this.ids.slice(i * size, (i + 1) * size);

                          setTimeout(function () {
                            window.MathJax.typesetPromise(showIds.map(function (id) {
                              return ".question-" + id;
                            }));
                          }, 10);
                        };

                        for (i = 0; i < count; i++) {
                          _loop(i);
                        }

                      case 6:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              })));

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function created() {
      return _created.apply(this, arguments);
    }

    return created;
  }(),
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      _this2.scrollbarWrap = _this2.$refs.scroll.$el.querySelector(".el-scrollbar__wrap");

      _this2.scrollbarWrap.addEventListener("scroll", _this2.showContent);

      document.addEventListener("scroll", _this2.setFixed);
      document.addEventListener("resize", _this2.setFixed);
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.scrollbarWrap.removeEventListener("scroll", this.showContent);
    document.removeEventListener("scroll", this.setFixed);
    document.removeEventListener("resize", this.setFixed);
  },
  methods: {
    showContent: function () {
      var _showContent = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var $, placeholderOffset, height, showId, i, id;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                $ = window.$;
                placeholderOffset = $(this.$refs.placeholder).offset();
                height = this.$refs.scroll.$el.offsetHeight;

                if (!(placeholderOffset.top - 118 - 10 > height)) {
                  _context3.next = 5;
                  break;
                }

                return _context3.abrupt("return");

              case 5:
                i = 0;

              case 6:
                if (!(i < this.ids.length)) {
                  _context3.next = 14;
                  break;
                }

                id = this.ids[i];

                if (this.showQuestion[id]) {
                  _context3.next = 11;
                  break;
                }

                showId = id;
                return _context3.abrupt("break", 14);

              case 11:
                i++;
                _context3.next = 6;
                break;

              case 14:
                if (!showId) {
                  _context3.next = 21;
                  break;
                }

                this.showQuestion[showId] = true;
                _context3.next = 18;
                return this.$nextTick();

              case 18:
                _context3.next = 20;
                return window.MathJax.typesetPromise([".question-" + showId]);

              case 20:
                this.showContent();

              case 21:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function showContent() {
        return _showContent.apply(this, arguments);
      }

      return showContent;
    }(),
    setFixed: function setFixed() {
      var $ = window.$;

      if ($(window).scrollTop() + 84 > 203) {
        this.fixed = true;
        this.fixedRight = ($(window).width() - 1200) / 2;

        if (this.fixedRight < 0) {
          this.fixedRight = 0;
        }
      } else {
        this.fixed = false;
      }
    },
    scrollTo: function () {
      var _scrollTo = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(id) {
        var $, top, ids, i;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (this.showQuestion[id]) {
                  _context5.next = 6;
                  break;
                }

                this.showQuestion[id] = true;
                _context5.next = 4;
                return this.$nextTick();

              case 4:
                _context5.next = 6;
                return window.MathJax.typesetPromise([".question-" + id]);

              case 6:
                $ = window.$;
                top = $("#" + id).offset().top + $(this.scrollbarWrap).scrollTop() - 118;
                $(this.scrollbarWrap).scrollTop(top);
                ids = [];
                i = 1;

              case 11:
                if (!(i < id)) {
                  _context5.next = 19;
                  break;
                }

                if (!this.showQuestion[i]) {
                  _context5.next = 14;
                  break;
                }

                return _context5.abrupt("continue", 16);

              case 14:
                this.showQuestion[i] = true;
                ids.push(i);

              case 16:
                i++;
                _context5.next = 11;
                break;

              case 19:
                _context5.next = 21;
                return this.$nextTick();

              case 21:
                ids.forEach(function (i) {
                  setTimeout(
                  /*#__PURE__*/
                  _asyncToGenerator(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee4() {
                    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            _context4.next = 2;
                            return window.MathJax.typesetPromise([".question-" + i]);

                          case 2:
                          case "end":
                            return _context4.stop();
                        }
                      }
                    }, _callee4);
                  })), 1);
                });

              case 22:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function scrollTo(_x) {
        return _scrollTo.apply(this, arguments);
      }

      return scrollTo;
    }(),
    goRepeat: function () {
      var _goRepeat = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6() {
        var is_can_do;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!(this.reportType && this.reportType == "random")) {
                  _context6.next = 5;
                  break;
                }

                _context6.next = 3;
                return this.$refs.limitModal.checkAnswer(1, "随机练习");

              case 3:
                _context6.next = 21;
                break;

              case 5:
                if (!(this.reportType && this.reportType == "special")) {
                  _context6.next = 10;
                  break;
                }

                _context6.next = 8;
                return this.$refs.limitModal.checkAnswer(3, "专项练习");

              case 8:
                _context6.next = 21;
                break;

              case 10:
                if (!(this.reportType && this.reportType == "package")) {
                  _context6.next = 21;
                  break;
                }

                is_can_do = this.scantron.is_can_do || "";

                if (!(is_can_do && is_can_do == 2)) {
                  _context6.next = 18;
                  break;
                }

                //会员过期
                this.visible = true;
                this.questionType = "套卷练习";
                return _context6.abrupt("return");

              case 18:
                if (!(is_can_do && is_can_do == 3)) {
                  _context6.next = 21;
                  break;
                }

                //判断有没有权限进入套卷练习
                this.$message.warning("您没有权限进入");
                return _context6.abrupt("return");

              case 21:
                this.$emit("goRepeat");

              case 22:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function goRepeat() {
        return _goRepeat.apply(this, arguments);
      }

      return goRepeat;
    }()
  }
};